import React, { useState, useEffect } from 'react';
import Fornecedor from '../fornecedores/Fornecedor';
import MateriaPrima from '../materiaPrima/MateriaPrima';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import PerfilDropdown from "./PerfilDropdown";
import Produto from '../produto/Produto';
import CadastrarPerfil from '../CadastroPerfilUsuario/CadastrarPerfil';
import './Dashboard.css';
import CadastrarUsuario from '../CadastroPerfilUsuario/CadastrarUsuario';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';
import Cronoanalise from '../Cronoanalise/Cronoanalise';
import QualidadeHome from '../qualidade/QualidadeHome';
// import TesteCalce from '../qualidade/TesteCalce'; // Não usado diretamente
import LinhaProducao from '../qualidade/LinhaProducao';
import Devolucoes from '../qualidade/Devolucoes';
import CatalogoVirtualPage from '../qualidade/CatalogoVirtualPage';
import Contato from './Contato';
import Compra from '../compras/Compra';

import { FaIndustry, FaUsers, FaClipboardList, FaCog, FaChartLine, FaShoppingCart, FaListAlt, FaFileAlt, FaShoppingBag } from 'react-icons/fa';
import { MdSupport, MdEngineering } from 'react-icons/md';

import CadastroPedidoVenda from '../vendas/CadastroPedidoVenda';
import ListagemPedidosVenda from '../vendas/ListagemPedidosVenda';
import DetalhesPedidoVenda from '../vendas/DetalhesPedidoVenda';

const Dashboard = () => {
  // Controle de pedido selecionado para detalhes
  const [pedidoSelecionadoId, setPedidoSelecionadoId] = useState(null);
  const [formularioAtivo, setFormularioAtivo] = useState(() => {
    // Preserva a aba ativa entre reloads. Se não houver valor salvo, mantém 'suporte' por compatibilidade.
    try {
      const saved = localStorage.getItem('formularioAtivo');
      return saved || 'suporte';
    } catch (e) {
      return 'suporte';
    }
  });

  const [menuAberto, setMenuAberto] = useState(false);

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  const abrirFormulario = (formulario) => {
    setFormularioAtivo(formulario);
    localStorage.setItem('formularioAtivo', formulario);
    setMenuAberto(false);
  };

  useEffect(() => {
    localStorage.setItem('formularioAtivo', formularioAtivo);
  }, [formularioAtivo]);

  useEffect(() => {
    const handler = (e) => {
      try {
        const tab = e?.detail?.tab || localStorage.getItem('formularioAtivo');
        if (tab) setFormularioAtivo(tab);
      } catch (err) {
        // ignore
      }
    };
    window.addEventListener('setDashboardTab', handler);
    return () => window.removeEventListener('setDashboardTab', handler);
  }, []);

  const obterTitulo = () => {
    switch (formularioAtivo) {
      case 'fornecedor':
        return 'Gestão de Fornecedores';
      case 'materiaPrima':
        return 'Controle de Matéria Prima';
      case 'produto':
        return 'Catálogo de Produtos';
      case 'cronoanálise':
        return 'Cronoanálise de Tempos Produtivos';
      case 'layout':
        return 'Layout de Produção';
      case 'qualidade':
        return 'Teste de Calce';
      case 'testeCalce':
        return 'Catálogo Virtual';
      case 'linhaProducao':
        return 'Linha de Produção';
      case 'devolucoes':
        return 'Devoluções';
      case 'modEmoi':
        return 'Gestão MOD/MOI';
      case 'suporte':
        return 'Suporte Online - ProcessStepWise';
            case 'cadastroPedidoVenda':
              return '';
            case 'listagemPedidosVenda':
              return '';
      case 'compras':
        return 'Gestão de Compras';
      default:
        return 'Dashboard ProcessStepWise';
    }
  };


  return (
    <div className="dashboard">
      <div className={`sidebar ${menuAberto ? 'menu-aberto' : ''}`}> 
        {/* Perfil no topo */}
        <div className="perfil-container">
          <PerfilDropdown />
        </div>

        <div className="menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <Nav variant="pills" className={`nav ${menuAberto ? 'active' : ''}`}> 
            {/* Módulo de Vendas/Pedidos */}
            <NavDropdown title={<><FaShoppingCart /> Vendas & Pedidos</>} id="nav-dropdown-vendas">
              <NavDropdown.Item onClick={() => abrirFormulario('cadastroPedidoVenda')}>
                <FaFileAlt style={{marginRight: 6}}/> Cadastro de Pedido de Venda
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => abrirFormulario('listagemPedidosVenda')}>
                <FaListAlt style={{marginRight: 6}}/> Listagem de Pedidos
              </NavDropdown.Item>
              {/* Exemplo de acesso rápido a detalhes (poderia ser via modal ou navegação futura) */}
              {/* <NavDropdown.Item onClick={() => abrirFormulario('detalhesPedidoVenda')}>
                <FaClipboardList style={{marginRight: 6}}/> Detalhes de Pedido
              </NavDropdown.Item> */}
            </NavDropdown>
          <Nav.Item>
            <Nav.Link onClick={() => abrirFormulario('suporte')}>
              <MdSupport /> Suporte Online
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link onClick={() => abrirFormulario('mes')}>
              <FaIndustry /> MES
            </Nav.Link>
          </Nav.Item>

          {/* PCP / Estoque & Produção */}
          <NavDropdown title={<><FaClipboardList /> PCP / Estoque & Produção</>} id="nav-dropdown-pcp">
            <NavDropdown.Item as="a" href="/estoque/movimentacao">
              Movimentação de Estoque
            </NavDropdown.Item>
            <NavDropdown.Item as="a" href="/estoque/saldo">
              Consulta de Saldo
            </NavDropdown.Item>
            <NavDropdown.Item as="a" href="/estoque/historico">
              Histórico de Movimentação
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item as="a" href="/ordem/cadastro">
              Cadastro de Ordem de Produção
            </NavDropdown.Item>
            <NavDropdown.Item as="a" href="/ordem/insumos">
              Insumos da Ordem de Produção
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={() => abrirFormulario('compras')}>
              <FaShoppingBag style={{marginRight: 6}}/> Gestão de Compras
            </NavDropdown.Item>
          </NavDropdown>

          <NavDropdown title={<><FaClipboardList /> Qualidade</>} id="nav-dropdown">
            <NavDropdown.Item onClick={() => abrirFormulario("qualidade")}> 
              Teste de calce
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={() => abrirFormulario("testeCalce")}> 
              Catálogo Virtual
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => abrirFormulario("linhaProducao")}> 
              Linha de Produção
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => abrirFormulario("devolucoes")}> 
              Devoluções
            </NavDropdown.Item>
          </NavDropdown>

          <PermissionGate permissions={["cadastrarUsuarios"]}>
            <NavDropdown title={<><FaUsers /> Usuários</>} id="nav-dropdown">
              <NavDropdown.Item onClick={() => abrirFormulario("CadastrarUsuario")}> 
                Cadastrar Usuário
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => abrirFormulario("CadastrarPerfil")}> 
                Cadastrar Perfil
              </NavDropdown.Item>
            </NavDropdown>
          </PermissionGate>

          <NavDropdown title={<><MdEngineering /> Engenharia</>} id="nav-dropdown">
            <NavDropdown.Item onClick={() => abrirFormulario("cronoanálise")}> 
              <FaChartLine /> Cronoanálise
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => abrirFormulario("layout")}> 
              <FaClipboardList /> Layout
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => abrirFormulario("modEmoi")}> 
              <FaCog /> MOD e MOI
            </NavDropdown.Item>
          </NavDropdown>

          <NavDropdown title={<><FaClipboardList /> Cadastros</>} id="nav-dropdown">
            <NavDropdown.Item onClick={() => abrirFormulario("fornecedor")}> 
              Fornecedor
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => abrirFormulario("materiaPrima")}> 
              Matéria Prima
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => abrirFormulario("produto")}> 
              Produtos
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </div>

      <div className="content">
        <h1 className="titulo">{obterTitulo()}</h1>

        {formularioAtivo === 'fornecedor' && <Fornecedor />}
        {formularioAtivo === 'materiaPrima' && <MateriaPrima />}
        {formularioAtivo === 'produto' && <Produto />}
        {formularioAtivo === 'CadastrarPerfil' && <CadastrarPerfil />}
        {formularioAtivo === 'CadastrarUsuario' && <CadastrarUsuario />}
        {formularioAtivo === 'cronoanálise' && <Cronoanalise />}
        {formularioAtivo === 'qualidade' && <QualidadeHome />}
        {formularioAtivo === 'testeCalce' && <CatalogoVirtualPage />}
        {formularioAtivo === 'linhaProducao' && <LinhaProducao />}
        {formularioAtivo === 'devolucoes' && <Devolucoes />}
        {formularioAtivo === 'suporte' && <Contato />}
          {formularioAtivo === 'cadastroPedidoVenda' && <CadastroPedidoVenda />}
          {formularioAtivo === 'listagemPedidosVenda' && (
            <ListagemPedidosVenda
              onSelecionarPedido={id => {
                setPedidoSelecionadoId(id);
                setFormularioAtivo('detalhesPedidoVenda');
              }}
            />
          )}
          {formularioAtivo === 'detalhesPedidoVenda' && pedidoSelecionadoId && (
            <DetalhesPedidoVenda pedidoId={pedidoSelecionadoId} onVoltar={() => setFormularioAtivo('listagemPedidosVenda')} />
          )}
        {formularioAtivo === 'compras' && <Compra />}
        {formularioAtivo === 'layout' && (
          <div className="dashboard-cards">
            <div className="dashboard-card">
              <h3>Layout de Produção</h3>
              <p>Configure o layout da sua linha de produção</p>
            </div>
          </div>
        )}
        {formularioAtivo === 'modEmoi' && (
          <div className="dashboard-cards">
            <div className="dashboard-card">
              <h3>Gestão MOD/MOI</h3>
              <p>Gerencie mão de obra direta e indireta</p>
            </div>
          </div>
        )}
        {!formularioAtivo && (
          <div className="dashboard-cards">
            <div className="dashboard-card">
              <h3>Bem-vindo ao ProcessStepWise</h3>
              <p>Selecione uma opção no menu para começar</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
